/* ===========================================================================
   carrinho-substitui.js — comprar SUBSTITUI o carrinho, nao soma.

   Arquivo IDENTICO na Be Neo e na CalmWave. Mudou num, copie no outro.

   Por que existe (15/09/2026, docs/99-registro.md das duas lojas): toda compra
   daqui pula o carrinho e vai direto ao checkout. So que o /cart/add.js SOMA ao
   que ja estava no carrinho, e o carrinho fica guardado no navegador por dias.
   Quem voltava do checkout e clicava de novo levava as duas coisas: pack x2 e
   x3, os dois bracos do teste de preco no mesmo checkout, 11 aparelhos. E o
   checkout do plano Shopify nao deixa tirar item. Medido nos pedidos: vira
   reembolso quando o cliente paga e abandono quando nao paga.

   O que faz, em toda compra:
   1. ESVAZIA o carrinho (/cart/clear.js) e so segue quando a resposta (que e
      o proprio carrinho) diz item_count 0 — senao espera 0,3 s e tenta de
      novo, ate 3 vezes. O clear.js apaga ITENS: atributos (o __clickid do
      tracker) e nota ficam. Doc da Shopify, e medido no ar em 15/09/2026.
   2. ADICIONA o que o cliente escolheu.
   3. CONFERE o carrinho que vai ao checkout (/cart.js, sem cache) e deixa nele
      EXATAMENTE o que esta compra pediu: linha que sobrou de antes vai a zero,
      quantidade a mais volta ao pedido (/cart/update.js por chave de linha).
   Uma compra por vez: o segundo toque recebe a mesma compra, nao soma.
   Voltando pelo "voltar" do navegador (bfcache), destrava o botao.
   Nenhum passo impede a compra: se um falhar, segue como antes.

   Por que os tres passos, e nao so o primeiro: no teste de ponta a ponta de
   15/09, com so o esvaziar, a primeira volta do checkout depois de uma compra
   feita com o carrinho vazio saiu somada duas vezes (BM3 + BM5; aparelho x2 +
   x1). Instrumentado, o mesmo cenario passava, e a causa nao foi provada. A
   conferencia final nao depende da causa: o que chega ao checkout e o que foi
   pedido. Custa uma leitura (~0,3 s).

   Como cada pagina usa:
   - Script de compra: window.carrinhoSubstitui.adicionar(items) no lugar de
     fetch('/cart/add.js'). Devolve o mesmo que fetch + json devolviam. Quem
     monta o proprio fluxo (add + update do ebook, add + change do seguro) usa
     substituir(passo, esperado), dizendo o que o carrinho tem de conter no fim.
     Todo script cai no fetch direto se este arquivo nao carregou: ordem de
     carga nao quebra compra nenhuma.
   - Formulario nativo para /cart/add que vai ao checkout: ligado aqui mesmo.
     Sem atributo, so os que tem return_to=/checkout. Com data-forms="todos"
     na tag <script>, todos (CalmWave: la o /cart repassa ao checkout, entao
     todo formulario de adicionar "pula o carrinho"). O formulario vira uma
     compra por fetch, com os mesmos campos, e segue para onde iria (return_to,
     ou /cart). Formulario que nao da para ler cai no envio nativo.

   O fetch e sempre o window.fetch DA HORA: o meta-pixel e o tracker embrulham
   o window.fetch para ver o /cart/add.js, e guardar uma referencia antiga
   passaria por fora deles — sem AddToCart.
   =========================================================================== */
(function () {
  'use strict';
  if (window.carrinhoSubstitui) return;

  var tag = document.currentScript;
  var FORMS_TODOS = !!(tag && tag.getAttribute('data-forms') === 'todos');
  var DESTRAVA_MS = 10000;   /* se a pagina nao saiu em 10 s, o botao volta */
  var REPETE_MS = 300;       /* espera entre tentativas de esvaziar */
  var TENTATIVAS = 3;

  var emCurso = null;        /* a compra em andamento */
  var trava = null;
  var correcoes = 0;         /* quantas vezes a conferencia final consertou o carrinho */

  function buscar() { return window.fetch.apply(window, arguments); }

  function limpar() {
    try {
      return buscar('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function esvaziar() {
    var feitas = 0;
    function tentar() {
      feitas++;
      return limpar()
        .then(function (r) {
          if (!r || !r.ok) return false;
          return r.json().then(
            function (c) { return !c || typeof c.item_count !== 'number' || c.item_count === 0; },
            function () { return true; }
          );
        }, function () { return false; })
        .then(function (vazio) {
          if (vazio || feitas >= TENTATIVAS) return;
          return new Promise(function (pronto) { setTimeout(pronto, REPETE_MS); }).then(tentar);
        });
    }
    return tentar().then(function () {}, function () {});   /* nunca impede a compra */
  }

  /* Deixa no carrinho exatamente `esperado` ([{id, quantity}]). O /cart.js lista
     a linha mais nova primeiro: havendo duas da mesma variante, fica a desta
     compra, e a antiga vai a zero. */
  function conferirFinal(esperado) {
    if (!esperado || !esperado.length) return Promise.resolve();
    var resta = {};
    esperado.forEach(function (i) {
      var id = String(i.id);
      resta[id] = (resta[id] || 0) + (Number(i.quantity) || 1);
    });
    try {
      return buscar('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.items) return;
          var updates = {}, conserto = false;
          c.items.forEach(function (l) {
            var id = String(l.variant_id), quer = resta[id] || 0, fica = Math.min(l.quantity, quer);
            resta[id] = quer - fica;
            if (fica !== l.quantity) { updates[l.key] = fica; conserto = true; }
          });
          if (!conserto) return;
          correcoes++;
          return buscar('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function () {}, function () {});   /* nunca impede a compra */
    } catch (e) {
      return Promise.resolve();
    }
  }

  /* Esvazia, roda `passo` (que adiciona) uma vez so mesmo com toque duplo, e
     confere o carrinho contra `esperado`. */
  function substituir(passo, esperado) {
    if (emCurso) return emCurso;
    var resultado;
    emCurso = esvaziar()
      .then(function () { return passo(); })
      .then(function (res) { resultado = res; return conferirFinal(esperado); })
      .then(function () {
        clearTimeout(trava);
        trava = setTimeout(function () { emCurso = null; }, DESTRAVA_MS);
        return resultado;
      }, function (erro) {
        emCurso = null;
        throw erro;
      });
    return emCurso;
  }

  function adicionar(items) {
    return substituir(function () {
      return buscar('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.ok ? r.json() : r.json().then(function (e) { throw e; });
      });
    }, items);
  }

  /* Le id, quantity, selling_plan e properties[...] do formulario. Formulario de
     varios itens (items[][id]) ou sem id: null, e fica o envio nativo. */
  function itemDoForm(form) {
    try {
      var fd = new FormData(form);
      if (fd.getAll('items[][id]').length) return null;
      var id = parseInt(fd.get('id'), 10);
      if (!id) return null;
      var item = { id: id, quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) };
      var plano = parseInt(fd.get('selling_plan'), 10);
      if (plano) item.selling_plan = plano;
      var props = {}, tem = false;
      fd.forEach(function (v, k) {
        var m = /^properties\[(.+)\]$/.exec(k);
        if (m && v !== '') { props[m[1]] = v; tem = true; }
      });
      if (tem) item.properties = props;
      return item;
    } catch (e) {
      return null;
    }
  }

  /* Formularios nativos. Em bolha, no document: o handler da propria secao
     roda antes e, se ele ja cuida do envio (preventDefault), este sai de lado.
     O meta-pixel escuta em captura e o tracker no proprio form, entao os dois
     ja viram o submit antes daqui — o AddToCart sai uma vez, pelo submit. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || !form.matches) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    var volta = form.querySelector('input[name="return_to"]');
    var vaiAoCheckout = !!(volta && String(volta.value).indexOf('/checkout') === 0);
    if (!FORMS_TODOS && !vaiAoCheckout) return;
    e.preventDefault();
    var nativo = function () { HTMLFormElement.prototype.submit.call(form); };
    var item = itemDoForm(form);
    if (!item) {
      substituir(function () { nativo(); })['catch'](function () {});
      return;
    }
    var destino = vaiAoCheckout ? String(volta.value) : '/cart';
    adicionar([item]).then(function () { window.location.href = destino; }, nativo);
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    emCurso = null;
    clearTimeout(trava);
  });

  window.carrinhoSubstitui = {
    adicionar: adicionar,
    substituir: substituir,
    esvaziar: esvaziar,
    ocupado: function () { return !!emCurso; },
    correcoes: function () { return correcoes; }
  };
})();
